export default {
  name: 'Console',
  data() {
    return {
      isDevelopment: process.env.NODE_ENV === 'development',
    };
  },
  methods: {
    log() {
      // @ts-ignore
      if ( this.isDevelopment ) {
        // @ts-ignore
        console.log.apply( null, arguments );
      }
    },
    warn() {
      // @ts-ignore
      if ( this.isDevelopment ) {
        // @ts-ignore
        console.warn.apply( null, arguments );
      }
    },
    error() {
      // @ts-ignore
      if ( this.isDevelopment ) {
        // @ts-ignore
        console.error.apply( null, arguments );
      }
    },
  },
};
